import { render } from "./DedicateDomain.vue?vue&type=template&id=2b4840b0&scoped=true"
import script from "./DedicateDomain.vue?vue&type=script&lang=js"
export * from "./DedicateDomain.vue?vue&type=script&lang=js"

import "./DedicateDomain.vue?vue&type=style&index=0&id=2b4840b0&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4840b0"]])

export default __exports__